import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Clock, Users, Briefcase, User, ArrowRight, Check } from 'lucide-react';

const handleScheduleCall = () => {
  window.open("https://calendly.com/kentfrazier/30-minutes", "_blank");
};

const formats = [
  {
    title: "Full-Day Immersion",
    duration: "6 hours",
    description: "Deep dive into the intersection of performance and presence. Transform how you show up under pressure through movement-based learning.",
    highlights: [
      "Master your edge: Develop unshakeable presence and emotional regulation",
      "Elevate your skills: Advanced technical abilities and strategic thinking",
      "Build authentic partnership: Communication skills that work on and off court"
    ]
  },
  {
    title: "Half-Day Experience",
    duration: "3 hours",
    description: "Concentrated exploration of key themes. Perfect introduction to our approach or focused work on specific developmental areas.",
    highlights: [
      "Core ParadoxEdge principles in action",
      "Practical tools for pressure moments and partnership dynamics",
      "Immediate applications for your next match or meeting"
    ]
  },
  {
    title: "Standalone Sessions",
    duration: "1 hour",
    description: "Bite-sized experiences exploring specific themes. Build your toolkit one session at a time or sample our approach.",
    highlights: [
      "Focus on single developmental themes",
      "Practical tools you can use immediately",
      "Low commitment way to experience our methodology"
    ]
  }
];

const PickleballPrograms = () => {
  return (
    <section className="bg-card">
      <div className="container-mobile section-spacing max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-primary font-semibold tracking-[0.15em] uppercase text-sm mb-2">
            Ways to Engage
          </p>
          <h2 className="text-foreground mb-4">
            Choose Your Experience
          </h2>
          <p className="text-foreground/85 text-lg max-w-2xl mx-auto">
            Choose the experience that fits your goals and schedule.
          </p>
        </div>

        {/* Program Formats */}
        <div className="grid gap-6 md:grid-cols-3 mb-16">
          {formats.map((format, i) => (
            <Card key={i} className="bg-background border border-border hover:border-primary/40 transition-all duration-500 hover:-translate-y-1 overflow-hidden">
              <div className="h-1 bg-gradient-to-r from-primary to-primary/60" />
              <CardContent className="p-6">
                <div className="flex items-center gap-2 text-primary mb-3">
                  <Clock className="h-4 w-4" />
                  <span className="text-sm font-semibold">{format.duration}</span>
                </div>
                <h3 className="text-foreground font-display text-xl mb-3">{format.title}</h3>
                <p className="text-foreground/85 text-sm leading-relaxed mb-5">{format.description}</p>
                <ul className="space-y-2">
                  {format.highlights.map((h, j) => (
                    <li key={j} className="flex items-start gap-2 text-sm text-foreground/90">
                      <Check className="h-4 w-4 text-primary flex-shrink-0 mt-0.5" />
                      <span>{h}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Specialized Programs */}
        <div className="grid gap-6 md:grid-cols-2">
          <Card className="bg-foreground text-background overflow-hidden">
            <div className="h-1 bg-gradient-to-r from-primary to-primary/40" />
            <CardContent className="p-8">
              <div className="flex items-center gap-3 mb-4">
                <Briefcase className="h-6 w-6 text-primary" />
                <h3 className="text-background font-display text-xl">Corporate & Team Programs</h3>
              </div>
              <p className="text-background/70 mb-5">
                Transform team dynamics through paradox and edge mastery. Where high performance meets emotional intelligence.
              </p>
              <ul className="space-y-2 mb-6">
                {["Full-day immersions & multi-day retreats", "Custom programs for 12–36 participants", "On-site or retreat center options"].map((t, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-background/60">
                    <Check className="h-4 w-4 text-primary flex-shrink-0 mt-0.5" />
                    <span>{t}</span>
                  </li>
                ))}
              </ul>
              <Button onClick={handleScheduleCall} variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-full">
                Learn More <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
            </CardContent>
          </Card>

          <Card className="bg-foreground text-background overflow-hidden">
            <div className="h-1 bg-gradient-to-r from-primary to-primary/40" />
            <CardContent className="p-8">
              <div className="flex items-center gap-3 mb-4">
                <User className="h-6 w-6 text-primary" />
                <h3 className="text-background font-display text-xl">Private & Executive Coaching</h3>
              </div>
              <p className="text-background/70 mb-5">
                Personalized development where your unique challenges become your greatest opportunities for growth.
              </p>
              <ul className="space-y-2 mb-6">
                {["Completely personalized methodology", "Flexible scheduling & location options", "Ongoing developmental partnerships available"].map((t, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-background/60">
                    <Check className="h-4 w-4 text-primary flex-shrink-0 mt-0.5" />
                    <span>{t}</span>
                  </li>
                ))}
              </ul>
              <Button onClick={handleScheduleCall} variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-full">
                Learn More <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default PickleballPrograms;
